function validateResponse(response) {
  if (!response.ok) {
    if (response.status === 401) {
      window.location.href =
        process.env.REACT_APP_HOST_API_URL + "/developer/mvc/auth/login";
      return null;
    } else {
      throw new Error("Unknown error occurred : " + response.statusText);
    }
  }
}

export function getNetPromoterScorePointsTrackingData(orgId) {
  return fetch(
    process.env.REACT_APP_HOST_API_URL +
      "/developer/mvc/adminConsole/api/organizations/" +
      orgId +
      "/net-promoter-score-points-tracking",
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "GET",
    }
  )
    .then((response) => ((validateResponse(response), response.json())))
    .catch((error) => {
      console.log(
        "Error getting NetPromoterScorePointsTracking data from server: " +
          error.message
      );
      window.location.href =
        process.env.REACT_APP_HOST_API_URL +
        "/developer/errorRedirect.jsp?errorKey=request.processing.error";
      return Promise.reject();
    });
}

export function deleteNetPromoterScorePointsTrackingData(id, csrfToken) {
  return fetch(
    process.env.REACT_APP_HOST_API_URL +
      "/developer/mvc/adminConsole/api/net-promoter-score-points-tracking/" +
      id,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": csrfToken,
      },
      credentials: "include",
      method: "Delete",
    }
  )
    .then((response) => validateResponse(response))
    .catch((error) => {
      console.log(
        "Error deleting NetPromoterScorePointsTracking data from server: " +
          error.message
      );
      window.location.href =
        process.env.REACT_APP_HOST_API_URL +
        "/developer/errorRedirect.jsp?errorKey=request.processing.error";
      return Promise.reject();
    });
}

export function addNetPromoterScorePointsTrackingData(payLoad, csrfToken) {
  return fetch(
    process.env.REACT_APP_HOST_API_URL +
      "/developer/mvc/adminConsole/api/net-promoter-score-points-tracking",
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": csrfToken,
      },
      credentials: "include",
      method: "Post",
      body: payLoad,
    }
  )
    .then((response) => {
      validateResponse(response);
    })
    .catch((error) => {
      console.log(
        "Error adding NetPromoterScorePointsTrackingData data from server: " +
          error.message
      );
      window.location.href =
        process.env.REACT_APP_HOST_API_URL +
        "/developer/errorRedirect.jsp?errorKey=request.processing.error";
      return Promise.reject();
    });
}

export function getNetPromoterScorePointsCategory() {
  return fetch(
    process.env.REACT_APP_HOST_API_URL +
      "/developer/mvc/adminConsole/api/net-promoter-score-points-tracking/categories",
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "GET",
    }
  )
    .then((response) => ((validateResponse(response), response.json())))
    .catch((error) => {
      console.log(
        "Error getting getNetPromoterScorePointsCategory data from server: " +
          error.message
      );
      window.location.href =
        process.env.REACT_APP_HOST_API_URL +
        "/developer/errorRedirect.jsp?errorKey=request.processing.error";
      return Promise.reject();
    });
}



// WEBPACK FOOTER //
// ./src/firstnet/NetPromoterScore/FetchCallsNetPromoterScorePointsTrackingData.js